import Image_Default from "../../images/man.png";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {connect} from "react-redux";
import axios from "axios";

const Home_CreateTwwet = (props) => {
    const [content,setContent] = useState("");
    const navigate = useNavigate();
    const {user,color_background,color_button} = props;

    const postTweet = async() => {
        try {
            const response = await axios.post("/newpost",{
                content:content,
                user_id:user.id
            },{
                withCredentials:true,
                headers:{
                    "Content-Type":"application/json"
                }
            });
            console.log("success");
            let input = document.getElementsByName("create_tweet_text")[0];
            input.value = "";
            setContent("");
            navigate("/");
        } catch (error) {
            console.log(error);
        }
    }
    return(
        <div className={`main_content_section main_content_section_${color_background} home_create_tweet`}>
            <div className="create_tweet_div">
                <img src={Image_Default} alt="User" className="user_image user_image_tweet" />
                <div className="create_tweet_text_div">
                    <textarea onChange={(e) => setContent(e.target.value)} className={`create_tweet_text profile_edit_form_input_color background_change_${color_background}`} rows="3" name="create_tweet_text" placeholder="What's happening?" required></textarea>
                    <div className={`main_content_section main_content_section_${color_background} create_tweet_text_hr`}></div>
                </div>
            </div>
            <div className="create_tweet_button_div">
                {
                    content.trim() ? 
                    <button onClick={postTweet} className={`create_tweet_button customizecolorchange_hover customizecolorchange_${color_button}`}>Tweet</button> :
                    <button onClick={postTweet} className={`create_tweet_button_disabled customizecolorchange_disabled_${color_button}`} disabled={true}>Tweet</button>
                }
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        color_button: state.getColorButton.color_button,
        color_background: state.getColorBackground.color_background,
        user: state.getUser.user
    }
}
export default connect(mapStateToProps)(Home_CreateTwwet);